module.exports = __webpack_public_path__ + "img/stock2.f77195d7.png";